'use client';

import { COMPANY_INFO } from '@/config/company';

/**
 * Fonction utilitaire pour vérifier si le magasin est actuellement ouvert
 */
export const isStoreOpen = () => {
  if (typeof window === 'undefined') {
    return false; // SSR safety
  }

  const now = new Date();
  const dayOfWeek = now.getDay(); // 0 = Dimanche, 1 = Lundi, etc.
  const currentTime = now.getHours() * 60 + now.getMinutes(); // Temps en minutes depuis minuit

  const dayKeys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const todayKey = dayKeys[dayOfWeek];
  const todayHours = COMPANY_INFO.businessHours[todayKey];

  if (!todayHours.open || !todayHours.close) {
    return false; // Fermé aujourd'hui
  }

  // Convertir les heures d'ouverture et de fermeture en minutes
  const [openHour, openMinute] = todayHours.open.split(':').map(Number);
  const [closeHour, closeMinute] = todayHours.close.split(':').map(Number);
  const openTime = openHour * 60 + openMinute;
  const closeTime = closeHour * 60 + closeMinute;

  return currentTime >= openTime && currentTime < closeTime;
};
